import React, { FC, PropsWithChildren } from 'react';

import { useStyles } from './styles';

export const StageSection: FC<PropsWithChildren> = ({ children }) => {
  const styles = useStyles();

  return <div className={styles.section}>{children}</div>;
};
